import React, {useState, useCallback, useEffect, useRef} from 'react';
import {ModalReadyAnswersGlobal} from "../../../utils/modal/ModalReadyAnswersGlobal";
import {formatErrors, validateEmail} from "../../../constants";
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import {updateQuickAnswerAction} from "../../../actions/quickAnswerAction";

export function ChatReadyAnswersModal({item, isEdit, handleComplete}) {
  const [open, setOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const textareaRef = useRef();

  const [form, setForm] = useState({
    id: '',
    name: '',
    message: ''
  });

  const handleOpen = (value) => {
    if (loading) {
      return;
    }
    setOpen(value);
  };

  const handleChangeForm = useCallback((e) => {
    const name = e.target.name;
    const value = e.target.value;
    setForm((form) => {
      return {...form, [name]: value}
    });
  }, []);

  const handleSubmit = (e) => {
      e.preventDefault();
    if (loading) {
      return false;
    }
    let errs = {};
    
    form.message = textareaRef.current.value.trim();
    
    if (form.name === '') {
      errs.name = true;
    }
    if (form.message === '') {
      errs.message = true;
    }
    setErrors(errs);
    if (Object.keys(errs).length > 0) {
      return false;
    }
    setLoading(true);

    dispatch(updateQuickAnswerAction(form)).then(() => {
      setLoading(false);
      setOpen(false);
      handleComplete();
    }).catch((e) => {
      setLoading(false);
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  const handleTemplate = (value) => {
    insertToMessage(value);
  };

  const insertToMessage = (value) => {
    if (textareaRef.current.value.length + value.length > 4096) {
      return;
    }
    const current = textareaRef.current.value;
    const position = textareaRef.current.selectionStart;
    textareaRef.current.value = current.substring(0, position) +
      value +
      current.substring(position, current.length);
    textareaRef.current.focus();
    textareaRef.current.setSelectionRange(position + value.length, position + value.length);
  };

  useEffect(() => {
    if (open) {
      setForm({
        id: item.id,
        name: item.name,
        message: item.message
      });
      setErrors({});
    }
  }, [open, item]);

  return <ModalReadyAnswersGlobal open={open} handleOpen={handleOpen} isEdit={isEdit} isStatic={true}>
    {open && <React.Fragment>
        <div className="main-popup__title">
            {form.id ? "Редактировать":"Добавить"} ответ
        </div>
        <form className="main-popup__form" noValidate onSubmit={handleSubmit}>
            <div className="main-popup__group">
                <div className="main-popup__label">
                    Ярлык
                </div>
                
                <input autoComplete="off" type="text"
                   name="name"
                   className={"main-control" + (errors.name ? " " : "")}
                   value={form.name}
                   disabled={loading}
                   onChange={handleChangeForm}/>
            </div>
            <div className="main-popup__group">
                <div className="main-popup__label">
                    Сообщение
                </div>
                
                <ChatReadyAnswersModalTextarea isEdit={isEdit} item={item} name={"message"} error={errors.message} loading={loading} textareaRef={textareaRef} />
                
            </div>
            <div className="main-popup__group">
                <div className="variable-list">
                    <div className="variable-list__item" onClick={() => handleTemplate('{real_name}')}>real_name</div>
                    <div className="variable-list__item" onClick={() => handleTemplate('{control}')}>control</div>
                </div>
            </div>
            <div className="main-popup__btn">
                <button type="submit" className="btn js-popup__close" onClick={handleSubmit} disabled={loading}>
                    {form.id ? "Сохранить":"Добавить"}
                </button>
            </div>
        </form>
    </React.Fragment>}
  </ModalReadyAnswersGlobal>
};

export function ChatReadyAnswersModalTextarea({isEdit, item, name, error, loading, textareaRef}) {
  useEffect(() => {
    if (isEdit && textareaRef.current != null) {
      textareaRef.current.value = item.message;
    }
  }, [item, isEdit, textareaRef]);
    
    return <textarea autoComplete="off" name={name}
                  className={"main-control" + (error ? " " : "")}
                  disabled={loading}
                    ref={textareaRef}></textarea>
}
